import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

export default function Testimonials({ data }) {
  return (
    <section data-testid="testimonials-section" className="py-24 lg:py-32 bg-alabaster">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <p className="overline mb-4" data-testid="testimonials-overline">{data.overline}</p>
          <h2
            data-testid="testimonials-title"
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-onyx"
          >
            {data.title}
          </h2>
          <p className="mt-4 text-onyx/70">{data.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {(data.items || []).map((t, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 border border-border hover:border-gold transition-colors"
            >
              <Quote size={28} className="text-gold mb-4" />
              <p className="font-serif text-xl leading-relaxed text-onyx italic mb-6">
                "{t.text}"
              </p>
              <div className="flex items-center gap-4">
                {t.image && (
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-12 h-12 rounded-full object-cover"
                  />
                )}
                <div>
                  <p className="font-semibold text-onyx">{t.name}</p>
                  <div className="flex gap-0.5 mt-1">
                    {Array.from({ length: t.rating || 5 }).map((_, k) => (
                      <Star key={k} size={12} className="text-gold" fill="currentColor" />
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
